import styled from "styled-components";
import { Heading1, Heading5 } from "../../components/Typography";
import { COLOR_WHITE } from "../../constants/colors";
import bgGolf from "../../images/bg-golf-course.jpg";
import IcTBTC from "../../images/icons/ic-tbtc.svg";

const Container = styled.div`
  min-height: 820px;
  display: flex;
  align-items: center;
  flex-direction: column;

  background-image: url(${bgGolf});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  padding: 50px 0px;

  @media (max-width: 768px) {
    min-height: 500px;
    padding: 30px 0px;
  }
`;

const LogoTBTC = styled.img`
  width: 120px;
  margin-bottom: 32px;

  @media only screen and (max-width: 569px) {
    width: 90px;
  }
`;

const Title = styled.h1`
  ${Heading1}
  color: ${COLOR_WHITE};
  text-align: center;
  margin-bottom: auto;
`;

const Hashtag = styled.div`
  ${Heading5}
  color: ${COLOR_WHITE};
`;

function HeroSection() {
  return (
    <Container>
      <LogoTBTC src={IcTBTC} alt="The Bear Tiger Club" />
      <Title>
        THE BEAR TIGER CLUB
        <br />
        Merch Shop
      </Title>
      <Hashtag>#HOODIESALLOWED</Hashtag>
      <Hashtag>#NOSLOWPLAY</Hashtag>
    </Container>
  );
}

export default HeroSection;
